module.exports = __webpack_public_path__ + "static/img/SketchPnga61ff6e8b54d05480d6b8c3078c36b6c55b0cfb6fb0b6cc7539ad71767f3e080.6b5b1127.png";